import React, { useMemo, useState } from 'react'
import { Dropdown, Icon, Label, Popup } from 'semantic-ui-react'
import _ from 'lodash'

const PopupSelect = ({ items, title, currentValue, onClick }) => {

  const [isOpen, setIsOpen] = useState(false)

  const trigger = <Label
    size='tiny'
    style={{ margin: '.5em', cursor: 'pointer' }}
    color='blue'
    title={title}
    onClick={(e) => {
      setIsOpen(true)
    }}
  >
    {_.startCase(currentValue)}
    <Icon name='angle right' style={{ marginLeft: '1em' }} />
  </Label>

  const popup = useMemo(() => {
    const options = _.map(items, item => (
      {
        text: _.startCase(item),
        key: item,
        value: item
      }))
    const ddi = <Dropdown options={options} value={currentValue} />
    return <Popup
      content={<div style={{ display: 'flex', flexDirection: 'column', gap: '.5em' }}>{ddi}</div>}
      on='click'
      pinned
      position='bottom left'
      basic
      size='tiny'
      style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)', width: '250px' }}
      trigger={trigger}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      closeOnDocumentClick
      flowing
    />
  }, [items, currentValue, isOpen])

  return popup

}

export default PopupSelect